export function formatExerciseOptionDisplayName(
  name: string,
  unit: string | undefined | null,
  unitKey: string | undefined,
): string {
  const unitPart = (unit?.trim() || unitKey?.trim() || '').trim();
  if (!unitPart) return name;
  return `${name}(${unitPart})`;
}

export function formatExerciseOptionSelectorLabel(
  name: string,
  unit: string | undefined | null,
  unitKey: string | undefined,
): string {
  return formatExerciseOptionDisplayName(name, unit, unitKey);
}
